<template>
  <div id="About">

    <page-hero headerText=message.hero.aboutHeader subText=message.hero.aboutSub></page-hero>

    <!--- About us text -->
    <div class="row mb-5 mb-lg-7 justify-content-center">
      <div class="col-10 col-sm-7 col-md-5 col-lg-4 col-xl-4">
        <h3 class="text-left text-nowrap">{{ $t('message.about.thisIsUs') }}</h3>
        <p>{{ $t('message.about.thisIsUsTxt1') }}</p>
        <p>{{ $t('message.about.thisIsUsTxt2') }}</p>
        <p>{{ $t('message.about.thisIsUsTxt3') }}</p>
        <p>{{ $t('message.about.thisIsUsTxt4') }}</p>
      </div>
      <div class="col-10 col-sm-2 col-md-3  col-xl-2 pt-3 pt-sm-0 text-center my-auto">
          <img class="icon-md" src="/static/images/astronaut_simple.png" alt="Illustration of an astronaut">
      </div>
      <div class="col-7 pt-5 pt-md-5 pt-lg-0  d-block d-sm-none text-center my-auto">
        <h4 class="light-grey-text font-weight-light">{{ $t('message.about.thisIsUsMobile') }}</h4>
      </div>
      <div>
      </div>
    </div>


    <!--- Section for SOLAR SYSTEM -->
    <div class="row slanted-container-left "/>

    <div class="row justify-content-center blue" id="solar-system">
      <div class="pb-14 pt-8">
        <solar-system class="responsive-solar"/>
      </div>
      <solar-system-mobile class="responsive-solar-mobile"/>
    </div>
    <div class="row slanted-container-right mb-5 mb-lg-7"/>

     <!-- Section for sponsors -->
     <div class="row justify-content-center mb-2 mb-lg-3">
      <div class="col-10 col-sm-8 col-md-6 col-xl-5">
        <h3  >{{ $t('message.about.values') }}</h3>
        <p>{{ $t('message.about.valuesTxt1') }}</p>
        <p>{{ $t('message.about.valuesTxt2') }}</p>
        <p>{{ $t('message.about.valuesTxt3') }}</p>
        <p>{{ $t('message.about.valuesTxt4') }}</p>
      </div>
     </div>
     <div class="row justify-content-center mb-5 mb-lg-7">
       <div class="col-10 col-sm-8 col-md-6 col-xl-5">
         <div class="row justify-content-center align-items-center">
            <div class="col-6 col-sm-3">
              <img class="w-100" src="/static/images/techeq_logo.jpg" alt="TechEq logo">
            </div>
            <div class="col-6 col-sm-3">
              <img class="w-100" src="/static/images/tjejer_kodar_logo.png" alt="Tjejer Kodar logo">
            </div>
            <div class="col-6 col-sm-3">
              <img class="w-100" src="/static/images/ingenjörer_logga.png" alt="Ingenjörer utan gränser logo">
            </div>
            <div class="col-6 col-sm-3">
              <img class="w-100" src="/static/images/pink-programming-logo.png" alt="Pink Programming logo">
            </div>
         </div>
       </div>
      </div>

    <!--- Section with blue backround -->
      <div class="row slanted-container-left "/>
      <div class="row blue justify-content-center align-items-center py-5 py-md-7">
        <div class="col-5 col-sm-2 col-md-3 col-xl-2 pb-4 pb-sm-0">
          <img src="/static/images/mars.svg" alt="Image of planet mars">
        </div>

        <div class="col-10 col-sm-7 col-md-5 col-lg-4 col-xl-3 my-auto">
          <h3 class="font-weight-light text-center text-sm-left">{{ $t('message.about.space') }}</h3>
          <p>{{ $t('message.about.spaceTxt') }}</p>
        </div>
      </div>
      <div class="row slanted-container-right mb-5 mb-lg-7"/>

      <!-- Last section: We build Precisit together-->
     <div class="row justify-content-center mb-5 mb-lg-7">
      <div class="col-10 col-sm-8 col-md-6 col-xl-5">
        <h3>{{ $t('message.about.build') }}</h3>
        <p>{{ $t('message.about.buildTxt1') }}</p>
        <p>{{ $t('message.about.buildTxt2') }}</p>
      </div>
     </div>

     <!-- picture -->
      <div class="row photo-section">

      </div>

    <page-footer></page-footer>
  </div>
</template>

<script>
import PageHero from '@/components/shared/PageHero';
import PageFooter from '../shared/PageFooter';
import SolarSystem from '../shared/SolarSystem';
import SolarSystemMobile from '../shared/SolarSystemMobile';

export default {
  name: 'AboutPage',
  components: {
    PageFooter,
    PageHero,
    SolarSystem,
    SolarSystemMobile,
  },
  data() {
    return {
      title: 'About page',
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/main.scss';

.photo-section {
  @include footer-banner('/static/images/new_space_mountains_4k.jpg');
}


.blue {
  background-color: $dark-blue;
  p, h3 {
  color: $white-text;
  }
}

.icon-md {
  width: 120px;
}

.slanted-container-right {
  @include slanted-container-right(white, $dark-blue, 0);
}

.slanted-container-left {
  @include slanted-container-left(white, $dark-blue, 0);
}

.responsive-solar {
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.responsive-solar-mobile {
  @media screen and (min-width: 769px) {
    display: none !important;
  }
}

</style>
